PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX ccf: <http://purl.org/ccf/>
PREFIX DSGraphs: <https://purl.humanatlas.io/collection/ds-graphs>
PREFIX DSGraphsExtra: <https://purl.humanatlas.io/graph/ds-graphs-enrichments>

CONSTRUCT {
  ?biomarker ccf:count ?count .
}
FROM DSGraphs:
FROM NAMED DSGraphsExtra:
WHERE {
  SELECT DISTINCT ?biomarker (COUNT(DISTINCT(?block)) AS ?count)
  WHERE {
    {
      GRAPH DSGraphsExtra: {
        ?rui_location ccf:collides_with_bm ?biomarker .
      }
    }
    UNION
    {
      BIND(ccf:Biomarker as ?biomarker)
    }

    ?block ccf:comes_from ?donor ;
      ccf:has_registration_location ?rui_location .
    OPTIONAL {
      ?block ccf:generates_dataset ?dataset .
    }
    OPTIONAL {
      ?block ccf:subdivided_into_sections ?section .
      OPTIONAL {
        ?section ccf:generates_dataset ?sectionDataset .
      }
    }

    #{{FILTER}}
  }
  GROUP BY ?biomarker
}
